export const locale = {
    lang: 'en',
    data: {
        APPOINTMENTS: {
            BUTTONS: {
                CREATE: 'Request Appointment'
            },
            TITLES: {
                NO_APPOINTMENTS: 'There are no appointments yet'
            }
        }
    }
};
